import useOnScreen from "hooks/useOnScreen";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
const TRANSITION_EFFECT = "all 2s ease";

const BigCard = ({ data, alts }) => {
  const [isMobile, setIsMobile] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isTab, setIsTab] = useState(false);
  const bigCardReference = useRef(null);
  const bigCardReference2 = useRef(null);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else if (window.innerWidth < 1080) {
      setIsTab(true);
    } else {
      setIsMobile(false);
      setIsTab(false);
    }
  }, []);

  const isOnScreen = isMobile
    ? // eslint-disable-next-line react-hooks/rules-of-hooks
      useOnScreen(bigCardReference2)
    : // eslint-disable-next-line react-hooks/rules-of-hooks
      useOnScreen(bigCardReference);

  return (
    <div className="flex flex-col lg:flex-row md:bg-big-card-color md:mt-16 md:mx-6 xl:mx-12 md:pb-12 xl:py-12 xl:px-16 rounded-lg font-gilroy">
      <div className="w-full lg:w-3/12 md:flex md:justify-center">
        <Image
          alt={alts}
          src={data.img}
          width={280}
          height={368}
          layout="fixed"
        />
      </div>
      <div className="w-full lg:w-9/12">
        <div>
          <div className="flex flex-col md:flex-row xl:mt-12 pt-16 xl:pt-4 md:pl-8">
            {/* details basic */}
            <div className="flex w-full md:w-1/3 flex-col mb-8 md:mb-0 md:ml-4 xl:ml-0">
              <div className="text-white font-semibold text-sm md:text-base">
                {data.biodetails.map((value) => (
                  <div key={value.que} className="flex pb-1">
                    <p className="w-1/2 text-celtic-blue text-sm font-bold">
                      <span className="font-gilroy">{value.que}</span>
                    </p>
                    <p className="text-white text-sm">
                      <span className="font-gilroy">{value.ans}</span>
                    </p>
                  </div>
                ))}
              </div>
            </div>
            {isMobile && (
              <>
                <div className="flex w-full md:w-1/3 flex-col mb-8 md:mb-0 md:ml-4 xl:ml-0">
                  <p className="font-bold text-xl text-celtic-blue">
                    <span className="font-gilroy">About Me :</span>
                  </p>
                  <p className="font-light md:font-semibold text-sm text-white w-full md:w-48">
                    <span className="font-gilroy">{data.aboutme}</span>
                  </p>
                </div>
                <div className="flex w-full md:w-1/3 flex-col mb-8 md:mb-0 md:ml-4 xl:ml-0">
                  <p className="font-bold text-xl text-celtic-blue">
                    <span className="font-gilroy">Interests :</span>
                  </p>
                  <p className="font-semibold text-sm text-white w-full md:w-48">
                    <span className="font-gilroy">{data.interests}</span>
                  </p>
                </div>
                <div className="flex w-full md:w-1/3 flex-col font-gilroy mb-8 md:mb-0 md:ml-4 xl:ml-0 mr-4">
                  <p className="font-bold text-xl text-celtic-blue">
                    <span className="font-gilroy">Device usage :</span>
                  </p>
                  {data.device.map((values) => (
                    <div
                      key={values.progresstitle}
                      ref={bigCardReference2}
                      className="mb-4"
                    >
                      <p className="text-white font-semibold text-sm mb-1">
                        <span className="font-gilroy">
                          {values.progresstitle}
                        </span>
                      </p>
                      <div className="bg-white w-full">
                        <div
                          className="bg-celtic-blue text-white p-1.5 text-right text-xl transition-all duration-[10s] ease-in"
                          style={{
                            width: isOnScreen ? values.progressvalue : "0%",
                            transition: TRANSITION_EFFECT,
                          }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="flex w-full md:w-1/3 flex-col font-gilroy mb-8 md:mb-0 md:ml-4 xl:ml-0">
                  <div>
                    <p className="font-bold text-xl text-celtic-blue">
                      <span className="font-gilroy">Motivations :</span>
                    </p>
                    <ul className="px-4">
                      {data.motivation.map((value) => (
                        <li
                          key={value}
                          className="font-semibold text-sm text-white mb-1 list-disc"
                        >
                          <span className="font-gilroy">{value}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="flex w-full md:w-1/3 flex-col font-gilroy mb-8 md:mb-0 md:ml-4 xl:ml-0">
                  <p className="font-bold text-xl text-celtic-blue">
                    <span className="font-gilroy">
                      Frustration / Pain Points :
                    </span>
                  </p>
                  <ul className="px-4">
                    {data.painpoints.map((values) => (
                      <li
                        key={values}
                        className="font-semibold text-sm text-white mb-1 list-disc"
                      >
                        <span className="font-gilroy">{values}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </>
            )}
            {/* motivation */}
            {!isMobile && (
              <div className="flex w-full md:w-1/3 flex-col font-gilroy mb-8 md:mb-0 md:ml-4 xl:ml-0">
                <div className="ps-3">
                  <p className="font-bold text-xl text-celtic-blue">
                    <span className="font-gilroy">Motivations :</span>
                  </p>
                  <ul className="px-4">
                    {data.motivation.map((value) => (
                      <li
                        key={value}
                        className="font-semibold text-sm text-white mb-1 list-disc"
                      >
                        <span className="font-gilroy">{value}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
            {/* device usage */}
            {!isMobile && (
              <div className="flex w-full md:w-1/3 flex-col font-gilroy mb-8 md:mb-0 md:ml-12 mr-4">
                <p className="font-bold text-xl text-celtic-blue">
                  <span className="font-gilroy">Device usage :</span>
                </p>
                {data.device.map((values) => (
                  <div
                    key={values.progresstitle}
                    ref={bigCardReference}
                    className="mb-4"
                  >
                    <p className="text-white font-semibold text-sm mb-1">
                      <span className="font-gilroy">
                        {values.progresstitle}
                      </span>
                    </p>
                    <div className="bg-white w-full">
                      <div
                        className="bg-celtic-blue text-white p-1.5 text-right text-xl transition-all duration-[10s] ease-in"
                        style={{
                          width: isOnScreen ? values.progressvalue : "0%",
                          transition: TRANSITION_EFFECT,
                        }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          {!isMobile && (
            <div className="flex flex-col md:flex-row md:mt-12 md:pl-8">
              {/* interests */}
              <div className="flex w-full md:w-1/3 flex-col font-gilroy mb-8 md:mb-0 md:ml-4 xl:ml-0">
                <p className="font-bold text-xl text-celtic-blue">
                  <span className="font-gilroy">Interests :</span>
                </p>
                <p className="font-semibold text-sm text-white w-full md:w-48">
                  <span className="font-gilroy">{data.interests}</span>
                </p>
              </div>
              {/* about me */}
              <div className="flex w-full md:w-1/3 flex-col font-gilroy mb-8 md:mb-0 md:ml-4 xl:ml-0">
                <p className="font-bold text-xl text-celtic-blue">About Me :</p>
                <p className="font-normal md:font-semibold text-sm text-white w-full md:w-48">
                  <span className="font-gilroy">{data.aboutme}</span>
                </p>
              </div>
              <div className="flex w-full md:w-1/3 flex-col font-gilroy mb-8 md:mb-0 md:ml-4 xl:ml-0">
                <p className="font-bold text-xl text-celtic-blue">
                  <span className="font-gilroy">
                    Frustration / Pain Points :
                  </span>
                </p>
                <ul className="px-4">
                  {data.painpoints.map((values) => (
                    <li
                      key={values}
                      className="font-semibold text-sm text-white mb-1 list-disc"
                    >
                      <span className="font-gilroy">{values}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default BigCard;
